import { render, staticRenderFns } from "./ServerListing.vue?vue&type=template&id=d81236a6&scoped=true"
import script from "./ServerListing.vue?vue&type=script&lang=js"
export * from "./ServerListing.vue?vue&type=script&lang=js"
import style0 from "./ServerListing.vue?vue&type=style&index=0&id=d81236a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81236a6",
  null
  
)

export default component.exports